import { race, call, take, takeEvery, select, getContext, put } from 'redux-saga/effects';
import {
  callFinishActions,
  callFinishByRemoteActions,
  startCall,
  startCallByRemote,
  newCustomerCall,
  initialized,
  setLocalStream,
} from './actions';
import selectors from './selectors';
import { getLogger } from '../../logger/index';
import { setRTCLocalStream, initLocalStream } from './kvsWebRTC';
import appSelectors from '../app/selectors';

const logger = getLogger('communicationVideo :: sagaUtils');

export function callDurringOutgoingCall(durringCallSaga, ...args) {
  return takeEvery(startCall, watchUntilFinishedCallSaga, durringCallSaga, ...args);
}

export function callDurringIncommingCall(durringCallSaga, ...args) {
  return takeEvery([startCallByRemote, newCustomerCall], watchUntilFinishedCallSaga, durringCallSaga, ...args);
}

export function callUntilFinishedCall(durringCallSaga, ...args) {
  return race({
    watch: call(durringCallSaga, ...args),
    cancel: take([...callFinishActions, ...callFinishByRemoteActions]),
  });
}

export function ensureCommsVideoInitialized() {
  return call(function* ensureCommsVideoInitializedSaga() {
    if (yield select(selectors.isInit)) {
      return;
    }

    yield take(initialized);
  });
}

function* watchUntilFinishedCallSaga(durringCallSaga, ...args) {
  try {
    logger.debug('Watch events durring call');
    const res = yield callUntilFinishedCall(durringCallSaga, ...args);
    logger.debug('Stop watching events durring incomming call');

    return res;
  } catch (e) {
    logger.error(e);
  }
}

export function* enableCameraAndMicSaga(type) {
  const mediaDevices = yield getContext('mediaDevices');
  const isAppActive = yield select(appSelectors.isActive);
  const localStream = yield call(initLocalStream, isAppActive ? type : 'audio', mediaDevices);
  yield put(setLocalStream(localStream));
  setRTCLocalStream(localStream);
}
